class ProductsListSlider extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.mobileQuery = window.matchMedia('(max-width: 989px)');
  }

  connectedCallback() {
    this.mobileDisplay = this.dataset.mobileDisplay || 'slider';
    this.initSwiper();
    this.initVariantSelectors();
    this.boundHandleResize = this.handleResize.bind(this);
    this.mobileQuery.addEventListener('change', this.boundHandleResize);
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
    this.mobileQuery.removeEventListener('change', this.boundHandleResize);
  }

  initSwiper() {
    const isMobile = this.mobileQuery.matches;
    const isGridMobile = isMobile && this.mobileDisplay === 'grid';

    this.swiper = new Swiper(this.querySelector('.swiper'), {
      direction: 'horizontal',
      loop: false,
      slidesPerView: 'auto',
      enabled: !isGridMobile,
      navigation: {
        prevEl: this.querySelector('.products-list__nav-prev'),
        nextEl: this.querySelector('.products-list__nav-next')
      },
      pagination: {
        el: this.querySelector('.products-list__pagination'),
        clickable: true
      }
    });
  }

  handleResize() {
    if (!this.swiper) return;
    const isMobile = this.mobileQuery.matches;
    const isGridMobile = isMobile && this.mobileDisplay === 'grid';

    if (isGridMobile) {
      this.swiper.disable();
    } else {
      this.swiper.enable();
    }
  }

  initVariantSelectors() {
    this.querySelectorAll('[data-variant-select]').forEach((select) => {
      this.preloadVariantImages(select);

      select.addEventListener('change', (event) => {
        const selectedOption = event.currentTarget.selectedOptions[0];
        const variantId = selectedOption.value;
        const price = selectedOption.dataset.price;
        const variantImage = selectedOption.dataset.image;

        const card = event.currentTarget.closest('.products-list-card');
        if (!card) return;

        const isAvailable = selectedOption.dataset.available === 'true';
        const addButton = card.querySelector('.products-list-card__atc');
        if (addButton) {
          if (isAvailable) {
            addButton.setAttribute('data-add-variant-id', variantId);
            addButton.setAttribute('quik-add', '');
            addButton.disabled = false;
            addButton.textContent = 'Ajouter au panier';
          } else {
            addButton.removeAttribute('data-add-variant-id');
            addButton.removeAttribute('quik-add');
            addButton.disabled = true;
            addButton.textContent = 'Épuisé';
          }
        }

        const priceEl = card.querySelector('.products-list-card__price');
        if (priceEl && price) {
          priceEl.textContent = price;
        }

        const imageContainer = card.querySelector('[data-card-image]');
        if (imageContainer) {
          const img = imageContainer.querySelector('img');
          if (img) {
            const newSrc = variantImage || imageContainer.dataset.fallbackImage;
            if (newSrc) {
              img.src = newSrc;
              img.srcset = '';
            }
          }
        }
      });
    });
  }

  preloadVariantImages(select) {
    select.querySelectorAll('option[data-image]').forEach((option) => {
      const img = new Image();
      img.src = option.dataset.image;
    });
  }

}

customElements.define('products-list-slider', ProductsListSlider);
